export const volumeStepper = (direction, step) => (value) => {
  // округляем значение громкости, чтобы шаг работал корректно.

  if (direction === "up") {
    return Math.round(value / step) * step + step;
  } else {
    return Math.round(value / step) * step - step;
  }
};
